import React, { useEffect } from 'react';
import { Normalize } from 'styled-normalize';
import { ThemeProvider } from 'styled-components';
import theme from './theme';
import Meta from './meta';
import GlobalStyle from './global-style';
import StyleElementProvider from './style-element';
import SiteModal from '../components/site-modal';

// this will only work when hydration is done.
// so on page transitions, it works.
// on page loads, the event listerener register is too late for the error.
const logImageErrorsToSentry = (event) => {
  if (!event.target) {
    return;
  }
  if (typeof Sentry === 'undefined') {
    console.error(event);
    console.warn('There is no Sentry, not sending body error...');
    return;
  }
  if (event.target.tagName === 'IMG') {
    Sentry.captureMessage(`Failed to load image: ${event.target.src}`, Sentry.Severity.Warning);
  }
};

const CoreLayout = ({ children, ...props }) => {
  useEffect(() => {
    document.body.addEventListener('error', logImageErrorsToSentry, true);
    return () => document.body.removeEventListener('error', logImageErrorsToSentry, true);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <StyleElementProvider scrollSnap={props.scrollSnap}>
        <Meta {...props}>
          <Normalize />
          <GlobalStyle />
          {children}
        </Meta>
        <SiteModal />
      </StyleElementProvider>
    </ThemeProvider>
  );
};

export default CoreLayout;
